/**
 * Whether a note is being written right now.
 *
 * Sync is the only thing in the app that can put text into an editor the user
 * did not type, so it is the only thing that has to stay out of the way while
 * they are typing. A cycle that lands mid-sentence pulls the server's copy of
 * the very paragraph being written — which is, by definition, older than what
 * is on screen — and hands it back to the editor.
 *
 * Deliberately a module-level timestamp rather than React state: every keystroke
 * touches it, and nothing should re-render because of that.
 */

/** How long after the last keystroke the app still counts as being written in. */
export const QUIET_MS = 1500;

let lastKeystroke = 0;

/** Called for every character typed into a note's title or body. */
export function noteTyping(): void {
  lastKeystroke = Date.now();
}

/**
 * Milliseconds still to wait before the user counts as having stopped typing.
 * Zero when they already have, which is the only time a cycle should start.
 */
export function untilQuiet(): number {
  return Math.max(0, lastKeystroke + QUIET_MS - Date.now());
}
